module.exports = __webpack_public_path__ + "static/img/banner.f945196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/banner.png
// module id = WHVL
// module chunks = 1